import React, { useState } from "react";
import CardExpression from "./CardExpression";
import BreadCrumb from "../../../../layout/BreadCrumb";
import ProjectDetails from "./ProjectDetails";
import BoqList from "./BoqList";
import Boq from "./Boq";
import ProjectDetailsSub from "./ProjectDetailsSub";
import Documents from "./Documents";
import { useSelector } from "react-redux";

function ExpressionViewLIst() {
  const { activeObjexpIsp } = useSelector((state) => ({
    activeObjexpIsp: state.obj.activeObj["expressionIsp"],
  })); 
  const [expand, setExpand] = useState(false);
  const handleExpand = () => {
    setExpand(!expand);
    setExpandDetails(false);
  };

  const [expandDetails, setExpandDetails] = useState(false);
  const handleExpandDetails = () => {
    setExpandDetails(!expandDetails);
    setExpand(false);
  };
 
  return (
    <div>
      <BreadCrumb
        breadcrumbs={[
          { title: "Farmers", path: "/farmers-list" },
          { title: "Expressions List", path: "/expression-of-interest" },
          { title: "Expressions ISP List", path: "/expression-isp-list" },
          { title: `Expression View ${activeObjexpIsp?.microIrrigationPartnerName}` },
        ]}
      />
      {expand ? (
        <>
          <Boq handleExpand={handleExpand} expand={expand} />
        </>
      ) : expandDetails ? (
        <>
          {" "}
          <ProjectDetails />
          <ProjectDetailsSub
            handleExpand={handleExpandDetails}
            expand={expandDetails}
          />
        </>
      ) : (
        <>
          <ProjectDetails />
          <CardExpression />
          <div className="flex lg:flex-row flex-col mt-[1.75rem] gap-x-3 lg:min-h-[45vh] flex-1">
            <div className="lg:w-[80%] w-full flex flex-col">
              <BoqList
                handleExpand={handleExpand}
                expand={expand}
                handleExpandDetails={handleExpandDetails}
                expandDetails={expandDetails}
              />
            </div>
            <div className="lg:w-[20%] w-full flex flex-col">
              <Documents />
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default ExpressionViewLIst;
